export const debounceWithCancel = (fn, delay) => {
  let timeoutId;
  return (...args) => {
    clearTimeout(timeoutId);
    timeoutId = setTimeout(() => fn(...args), delay);

    return () => clearTimeout(timeoutId);
  };
};
